/**
 * Links auf die Rechtstexte.
 *
 * Sie liegen auf der **Marketing-Seite**, nicht im Portal. Der Grund ist nicht Bequemlichkeit,
 * sondern dass es genau einen Satz Texte geben darf: Ein zweiter Abdruck der AGB im Portal
 * wäre ein zweiter Stand, den beim nächsten Lektorat jemand vergisst — und bei
 * Nutzungsbedingungen ist „welche Fassung galt am Tag der Registrierung?" keine akademische
 * Frage.
 *
 * Fällt `VITE_MARKETING_URL` weg, zeigen die Links auf die Produktionsdomain. Ein toter Link
 * auf ein Impressum wäre schlimmer als ein Link, der die Umgebung wechselt.
 */
const MARKETING_URL = (import.meta.env.VITE_MARKETING_URL ?? 'https://caterinx.com').replace(/\/$/, '');

export const LEGAL_LINKS = {
  imprint: `${MARKETING_URL}/impressum`,
  privacy: `${MARKETING_URL}/datenschutz`,
  termsSupplier: `${MARKETING_URL}/agb-lieferanten`,
  termsCustomer: `${MARKETING_URL}/agb-kunden`,
} as const;
